import React, { useState } from 'react';
import "react-morphing-modal/dist/ReactMorphingModal.css";
import { Col, Row, Table, Form, FormGroup, Input, CardBody, Media } from 'reactstrap';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import reportCxcCompanyAltImage from '../../assets/images/price/company-Ban.svg'
import reportCxcCompanyImage from '../../assets/images/price/reportCxcCompany.svg'
import * as XLSX from 'xlsx';


export const ModalCredit = (
  { close, companyInfo, formatter, navigateNim, valid_view, cancellPatient, countPatient, exportToExcelCancell, handleClosedView,
    ...props }) => {


  // ? CONFIGURATION SEARCH AND CHART 
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedPatients, setSelectedPatients] = useState([]);
  const [search, setSearch] = useState("");


  const handleCompanySelect = (company) => {
    setSelectedCompany(company);
    setSelectedPatients(company.patientDetails);
  };

  // ! CHART

  const chartData = companyInfo.map(company => {
    const totalAmount = company.patientDetails
      .filter(patient => patient.status_oreder === "Vigente")
      .reduce((total, patient) => total + (patient.amount || 0), 0);

    return {
      name: company.nameCompany,
      y: totalAmount,
      id_company: company.id_company,
    };
  });



  // ! OPTIONS CHART
  const options = {
    chart: {
      type: "pie",
    },
    title: {
      text: "Monto de creditos en empresas",
    },
    plotOptions: {
      pie: {
        innerSize: "50%",
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.percentage:.1f}%",
        },
      },
    },
    series: [
      {
        name: "Empresa",
        colorByPoint: true,
        data: chartData,
      },
    ],
  };

  const filteredCompanies = companyInfo.filter((company) =>
    company.nameCompany.toLowerCase().includes(search.toLowerCase())
  );

  const handleDownloadExcel = () => {
    if (!selectedPatients.length) {
      return;
    }

    const ws = XLSX.utils.json_to_sheet(selectedPatients.map(patient => ({

      Nim: patient.nim,
      Sucursal: patient.branchs,
      Paciente: patient.name_patient,
      Monto: patient.amount
    })));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Pacientes");

    XLSX.writeFile(wb, "pacientes.xlsx");
  };

  const sumMonto = selectedPatients.reduce((total, patient) => total + (patient.amount || 0), 0);





  return (


    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "200vh",
        overflow: "hidden",
      }}
    >
      <div className="pt-2" />

      <div style={{ flex: 1, overflow: "hidden" }}>
        {valid_view && (
          <Row className="h-100 pt-4">
            <Col sm="4" className="h-100 overflow-auto call-chat-sidebar">
              <CardBody className="chat-body h-100">
                <div className="chat-box h-100">
                  <div className="chat-left-aside h-100">
                    <div
                      className="media"
                      style={{ backgroundColor: "#1f9ad96b", color: "#fff" }}
                    >
                      <div className="name f-w-600 f-14">
                        Listado de Clientes
                      </div>
                    </div>

                    <div className="people-list">
                      <div className="search">
                        <Form className="theme-form">
                          <FormGroup>
                            <Input
                              type="text"
                              placeholder="Buscar empresa"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />
                            <i className="fa fa-search"></i>
                          </FormGroup>
                        </Form>
                      </div>

                      {filteredCompanies.length > 0 ? (
                        <ul className="list">
                          {filteredCompanies.map((company, index) => (
                            <li
                              key={company.id_company}
                              onClick={() => handleCompanySelect(company)}
                            >
                              <img
                                src={
                                  index % 2 === 0
                                    ? reportCxcCompanyImage
                                    : reportCxcCompanyAltImage
                                }
                                className="rounded-circle user-image"
                                alt=""
                              />
                              <div
                                className={`status-circle ${company.amount > 0 ? "online" : "offline"
                                  }`}
                              ></div>
                              <div className="about">
                                <div className="name">
                                  {company.nameCompany}
                                </div>
                                <div className="status f-w-600 f-12 txt-danger">
                                  {formatter.format(company?.amount ?? 0)}
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <Media className="img-fluid m-auto" alt="No data" />
                      )}
                    </div>
                  </div>
                </div>
              </CardBody>
            </Col>
            <Col sm="8" className="h-100 p-0">
              <CardBody className="h-100 p-0">
                <div className="chat h-100 d-flex flex-column">
                  {/* HEADER */}
                  <div className="chat-header clearfix">
                    <Row className="w-100">
                      <Col sm="9">
                        {selectedCompany?.nameCompany}
                      </Col>
                      <Col sm="3" className="text-right">
                        {selectedCompany && (
                          <button
                            onClick={handleDownloadExcel}
                            className="btn btn-primary"
                          >
                            Generar Excel
                          </button>
                        )}
                      </Col>
                    </Row>
                  </div>

                  {/* BODY */}
                  <div
                    className="chat-history custom-scrollbar"
                    style={{ flex: 1, overflowY: "auto" }}
                  >
                    {selectedPatients.length > 0 ? (
                      <Table striped size="sm">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Nim</th>
                            <th>Sucursal</th>
                            <th>Paciente</th>
                            <th>Monto</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedPatients.map((_find, _key) => (
                            <tr key={_find?.nim}>
                              <td>{_key + 1}</td>
                              <td>
                                <b
                                  className="txt-info pointer"
                                  onClick={() =>
                                    navigateNim(_find.id_work_order)
                                  }
                                >
                                  {_find?.nim}
                                </b>
                              </td>
                              <td>{_find?.branchs}</td>
                              <td>{_find?.name_patient}</td>
                              <td>{formatter.format(_find.amount)}</td>
                            </tr>
                          ))}
                          <tr>
                            <td colSpan="4" className="text-right">
                              Total:
                            </td>
                            <td>{formatter.format(sumMonto)}</td>
                          </tr>
                        </tbody>
                      </Table>
                    ) : (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                      />
                    )}
                  </div>
                </div>
              </CardBody>
            </Col>
          </Row>
        )}
      </div>

      <div className={!valid_view ? "d-none" : "text-right"}>
        <button className="butto-full-modal" onClick={() => handleClosedView()}>
          <label className="f-20">X</label>
        </button>
      </div>
    </div>


  )
}


